import { ITranslatedComponent, TransFN, TranslationResources, t } from './translation';

export abstract class BaseTransComponent implements ITranslatedComponent{
  abstract readonly translationResources: TranslationResources;
  t: TransFN = (str: string) => {
    return t(this.translationResources,str);
  }
}

